import React from 'react';
import { withStyles } from '@material-ui/styles';
import flowRight from 'lodash.flowright';
import { injectIntl } from 'react-intl';

import styles from '../styles';

function DeleteAddressConfimation({ classes, intl }) {
  return (
    <div className={classes.dialogTextContainer}>
      {intl.formatMessage({
        id: 'ADDRESS.DELETE_CONFIMATION'
      })}
    </div>
  );
}

export default flowRight(injectIntl, withStyles(styles))(DeleteAddressConfimation);